import styled from 'styled-components';

export const TopicPill = styled.div<{ backgroundColor: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 12px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: #ffffff;
  box-sizing: border-box;
`;

export const TopicIcon = styled.img`
  width: 16px;
  height: 16px;
  margin: 0;
  padding: 0;
  margin-right: 6px;
  filter: brightness(0) invert(1);
`;
export const TopicText = styled.span`
  font-size: 14px;
  line-height: 1;
  white-space: nowrap;
  color: inherit;
`;

export const PillWithBorder = styled.div<{ color: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  background-color: ${({ color }) => `${color}33`};
  color: ${({ theme }) => theme.colors.textPrimary};
  border: 1px solid ${({ color }) => `${color}66`};
`;
